export const initGmapsViewer = async (
    element,
    isMarkerVisible = false,
    coords = {}
) => {
    await loader.importLibrary("places");
    const lat = coords.latitude;
    const lng = coords.longitude;

    // coords for malaysia country
    const myLat = 4.210484;
    const myLng = 101.975766;

    const center = new google.maps.LatLng(lat || myLat, lng || myLng);
    const zoom = lat === undefined || lng === undefined ? 6 : 17;
    const map = new google.maps.Map(element, {
        center,
        zoom,
        mapTypeControl: false,
    });

    const marker = await initGmapsMarker(map);

    if (isMarkerVisible) {
        marker.setPosition(center);
        marker.setVisible(true);
    }

    return { map, marker };
};

export const initGmapsAutocomplete = async (element, options = null) => {
    await loader.importLibrary("places");
    options = options || {
        types: ["establishment"],
        fields: [
            "formatted_address",
            "geometry",
            "name",
            "address_component",
            "place_id",
        ],
    };

    const autocomplete = new google.maps.places.Autocomplete(element, options);

    return autocomplete;
};

export const initGmapsMarker = async (map) => {
    const marker = new google.maps.Marker({
        /**
         * The anchor point for the Google Maps marker icon.
         * This is an object with x and y coordinates, where x is 0 and y is -29.
         */
        anchorPoint: new google.maps.Point(0, -29),
        map,
    });

    return marker;
};
